import styled from "styled-components"

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;

  @media (max-width: 992px) {
    display: none;
  }
`

export const StyledP = styled.p`
  &:hover {
    color: rgba(223, 74, 50, 0.8) !important;
  }
`